<template>
	<div class="footer-warp">
		<div style="background: #082246;">
			<div class="footertopbox">
				<div v-for="(item,index) in menuList" :key='index' :class="activeName==item.name?'activefooternavbox':'footernavbox'">
					<span @click="gopageFn(item)">{{item.name}}</span>
				</div>
			</div>
		</div>
		<div style="background: #00132d;">

			<div class="footerCenter">
				<div class="linkbox">
					<div class="linkimg">
						<img src="@/assets/imgs/home/linkicon.png" /> 友情链接:
					</div>
					<div v-for="(item,index) in linkList" :key='index' class="jumplinkbox">
						<a :href='item.linkurl' target="_blank">{{item.name}}</a>
					</div>
				</div>
				<div class="aboutusbox">
					<div v-for="(item,index) in abousList" :key='index' class="itembox">
						<img :src="item.icon" class="imgbox" />
						<span>{{item.name}}</span>
						<img :src="item.img" v-if="item.img" class="iconimg" />

						<div v-if="item.data" class="icondata">
							<span>联系电话</span>
							<div v-for="(e,i) in item.data" :key="i">
								{{e.title}}
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
		<div style="background: #00132d;">
			<div class="footerbotbox">
				<div class="sponsorbox">公众号：中国人才交流协会</div>
				<div>备案号：京ICP备18015766号-1</div>
			</div>
		</div>

	</div>
</template>
<script>
export default {
	data() {
		return {
			menuList: [
				{ 'name': '首页', linkUrl: "/", },
				{ 'name': '新闻中心', linkUrl: "/news-secondpage/notice", },
				{ 'name': '党建工作', linkUrl: "/party-secondpage/party-leads", },
				{ 'name': '行业服务', linkUrl: "/industry-secondpage/mark-build", },
				{ 'name': '会员服务', linkUrl: "/member-service", },
				{ 'name': '培训服务', linkUrl: "/train-service", },
				{ 'name': '会议活动', linkUrl: "/meet-secondpage/meetactive", },
				{ 'name':"专家库", linkUrl: "/experts-think", },
				{ 'name': '协会概况', linkUrl: "/association-profile/introduct", },
				{ 'name': '分支机构', linkUrl: "/branch", },
				{ 'name': '能力指数测评', linkUrl: "/assessment-institutions", }
			],
			activeName: '',
			linkList: [
				{
					name: '中华人民共和国人力资源和社会保障部',
					linkurl: 'http://www.mohrss.gov.cn/'
				},
				{
					name: '中国社会组织政务服务平台',
					linkurl: 'https://chinanpo.mca.gov.cn/'
				},
				{
					name: '中央和国家机关社会组织党建平台',
					linkurl: 'http://xhshdj.qizhiwang.org.cn/GB/index.html'
				},
				{
					name: '共产党员网',
					linkurl: 'http://www.12371.cn/'
				},
			],
			abousList: [
				{					name: '联系我们', icon: require('@/assets/imgs/home/icon2.png'), data: [
						{ title: '办公室：010-88824565' },
						{ title: '发展部：010-88824569' },
						{ title: '会员部：010-68709272' },
						{ title: '信息部：010-68709390' },
					]				},
				{ name: '意见邮箱：xhmsc@zgrcjlxh.com', icon: require('@/assets/imgs/home/icon3.png') },
				{ name: '扫描二维码 立即关注', icon: require('@/assets/imgs/home/icon4.png'), img: require('@/assets/imgs/home/icon5.png'), },
			]
		};
	},

	methods: {
		gopageFn(item) {
			sessionStorage.setItem('clickMenu', item.name)
			this.$router.push({
				path: item.linkUrl,
			});
		}


	},
};
</script>
<style lang="less" scoped>
.footer-warp {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	.footertopbox {
		width: 1200px;
		margin: 0 auto;
		background: #082246;
		height: 74px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		// color: #fff;
		font-size: 15px;
		.footernavbox {
			padding: 0 15px;
			// opacity: 0.6;
			color: #c7cbd1;
			cursor: pointer;
			&:hover {
				color: #fff;
			}
		}
		.activefooternavbox {
			padding: 0px 15px;
			cursor: pointer;
		}
	}
	.footerCenter {
		width: 1200px;
		margin: 0 auto;
		background: #00132d;
		display: flex;
		flex-direction: column;
		justify-content: center;
		padding: 46px 0 32px 0;
		font-size: 15px;
		border-bottom: 1px solid rgba(221, 221, 221, 0.23);
		.linkbox {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			.jumplinkbox {
				a {
					padding: 0 15px;
					border-right: 1px solid #99a1ab;
					font-size: 15px;
					line-height: 30px;
					color: #99a1ab;
					&:hover {
						color: #fff;
					}
				}
				&:last-child {
					a {
						border: none;
					}
				}
			}
			.jumplinkbox:hover {
				color: #fff;
			}
			.linkimg {
				opacity: 0.6;
				color: #ffffff;
			}
		}
		.aboutusbox {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			.itembox {
				position: relative;
				.imgbox {
					margin-right: 3px;
					opacity: 0.6;
				}
				display: flex;
				flex-direction: row;
				align-items: center;
				color: #99a1ab;
				margin: 10px 22px 0 22px;
				// opacity: 0.6;
				&:last-child {
					cursor: pointer;
				}
				&:first-child {
					cursor: pointer;
				}
				&:hover {
					.iconimg {
						display: block;
					}
					.icondata {
						display: block;
					}
				}
				.iconimg {
					position: absolute;
					display: none;
					top: -157px;
					left: -93px;
				}
				.icondata {
					position: absolute;
					display: none;
					top: -80px;
					left: -196px;
					background: #fff;
					padding: 12px;
					color: #666;
					border-radius: 5px;
					span {
						color: #333;
						font-size: 18px;
						line-height: 36px;
					}
					div {
						line-height: 30px;
					}
				}
			}
		}
	}
	.footerbotbox {
		background: #00132d;
		width: 1200px;
		margin: 0 auto;
		display: flex;
		flex-direction: row;
		justify-content: center;

		div {
			padding: 12px 0 24px 0;
			font-size: 15px;
			line-height: 30px;
			color: #ffffff;
			opacity: 0.6;
		}

		.sponsorbox {
			margin-right: 50px;
		}
	}
}
</style>

